import { render, staticRenderFns } from "./DetailGES.vue?vue&type=template&id=0fed0506"
import script from "./DetailGES.vue?vue&type=script&lang=js"
export * from "./DetailGES.vue?vue&type=script&lang=js"
import style0 from "./DetailGES.vue?vue&type=style&index=0&id=0fed0506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports